import React, {useEffect} from "react";
import {Grid} from "@mui/material";

import {getLabelPreview, getLabelTypes} from "./Utils";
import {useAppStore} from "./Stores";

export const AppSelection: React.FC = () => {
  const labelTypes = getLabelTypes();
  const setLabelType = useAppStore.use.setLabelType();

  useEffect(() => {
    if (labelTypes.length === 1) {
      setLabelType(labelTypes[0]);
    }

  }, [labelTypes, setLabelType]);

  if (labelTypes.length === 1) {
    return null;
  }

  return (
    <Grid
      spacing={4}
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      id="appSelection"
    >
      <Grid item mt={9} xs={12}>
        <h1>Choisir votre modèle d’affichette</h1>
      </Grid>

      {labelTypes.map((labelType) => (
        <Grid item md={3} xs={12} key={labelType}>
          <div className="card">
            <h2>{labelType}</h2>
            <img onClick={() => setLabelType(labelType)} src={getLabelPreview(labelType)} />
          </div>
        </Grid>
      ))}
    </Grid>
  );
}

export default AppSelection;
